import { useEffect, useState } from 'react';
import { readCookie } from './readCookie';
import { writeCookie } from './writeCookie';
export const useCookie = (name) => {
    const [value, setValue] = useState('');
    useEffect(() => {
        setValue(readCookie(name));
    }, [name]);
    const setCookie = (newValue, options) => {
        writeCookie(name, newValue, options);
        setValue(newValue);
    };
    return [value, setCookie];
};
//# sourceMappingURL=useCookie.js.map
// @zapier/cookies@1.1.3 (6a0d73ece)
